/**
 * Le tre pagine di divisione, adesso che la sezione è una sola.
 *
 * `/divisions/marketing`, `/divisions/product` e `/divisions/design` erano tre
 * voci di menu separate. Marketing e Prodotto erano lo stesso componente con
 * un'etichetta diversa; Design mostrava invece le consegne, che sono un'altra
 * entità. Adesso la divisione è un filtro dentro Progetti.
 *
 * Questo file non è più una pagina: è il ponte che tiene vivi i vecchi
 * indirizzi. Chi ha un segnalibro su `/divisions/marketing`, o un link dentro
 * una vecchia notifica, arriva sull'elenco unico già filtrato su quella
 * divisione invece di trovare una pagina che non c'è più.
 *
 * Quando `/progetti` sarà registrata in App.tsx (vedi il resoconto), queste tre
 * route possono restare così come sono: costano un rimando e non rompono
 * niente. Il giorno in cui si decide che i vecchi link non servono più, si
 * cancellano le tre righe e si cancella questo file.
 */
import type { Division } from '@masamune/shared';
import { ProjectsPage } from './ProjectsPage';

export function DivisionPage({ division }: { division: Division }) {
  return <ProjectsPage initialDivision={division} />;
}
